<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true }" (click)="toggleOpen()">
        <span class="margin-right">Casing and Tubing</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">

    <table border="1">
      <caption>Casing and Tubing</caption>
      <thead>
        <tr>
          <th>Type</th>
          @for (column of columns; track column) {
            <th>{{column.name}}</th>
          }
        </tr>

      </thead>
      <tbody>
        @for (type of dataTypes; track type) {
          <tr [formGroupName]="type.code">
            <td>{{type.definition}}</td>
            <td style="width: 100px">
              <input type="number" formControlName="wellboreDiameter" />
              @if (fieldHasNotes(getFieldName(type.code, 'wellboreDiameter')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'wellboreDiameter')" [notes]="getFilteredNotes(getFieldName(type.code, 'wellboreDiameter'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 100px">
              <input type="number" formControlName="casingDiameter" />
              @if (fieldHasNotes(getFieldName(type.code, 'casingDiameter')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'casingDiameter')" [notes]="getFilteredNotes(getFieldName(type.code, 'casingDiameter'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 100px">
              <input type="number" formControlName="collarDiameter" />
              @if (fieldHasNotes(getFieldName(type.code, 'collarDiameter')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'collarDiameter')" [notes]="getFilteredNotes(getFieldName(type.code, 'collarDiameter'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 100px">
              <input type="number" formControlName="feetInstalled" />
              @if (fieldHasNotes(getFieldName(type.code, 'feetInstalled')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'feetInstalled')" [notes]="getFilteredNotes(getFieldName(type.code, 'feetInstalled'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 300px">
              <input type="number" formControlName="feetLeftInWell" />
              @if (fieldHasNotes(getFieldName(type.code, 'feetLeftInWell')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'feetLeftInWell')" [notes]="getFilteredNotes(getFieldName(type.code, 'feetLeftInWell'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td>
              <input type="number" formControlName="cementVolume" />
              @if (fieldHasNotes(getFieldName(type.code, 'cementVolume')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'cementVolume')" [notes]="getFilteredNotes(getFieldName(type.code, 'cementVolume'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 100px">
              <input type="number" formControlName="cementTop" />
              @if (fieldHasNotes(getFieldName(type.code, 'cementTop')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'cementTop')" [notes]="getFilteredNotes(getFieldName(type.code, 'cementTop'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 200px">
              <input type="number" formControlName="grade" />
              @if (fieldHasNotes(getFieldName(type.code, 'grade')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'grade')" [notes]="getFilteredNotes(getFieldName(type.code, 'grade'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 200px">
              <input type="number" formControlName="weight" />
              @if (fieldHasNotes(getFieldName(type.code, 'weight')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'weight')" [notes]="getFilteredNotes(getFieldName(type.code, 'weight'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td>
              <input type="number" formControlName="burstPressureRating" />
              @if (fieldHasNotes(getFieldName(type.code, 'burstPressureRating')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'burstPressureRating')" [notes]="getFilteredNotes(getFieldName(type.code, 'burstPressureRating'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td>
              <input type="number" formControlName="bottom" />
              @if (fieldHasNotes(getFieldName(type.code, 'bottom')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'bottom')" [notes]="getFilteredNotes(getFieldName(type.code, 'bottom'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
            <td style="width: 1100px">
              <select formControlName="toolType">
                @for (type of toolTypes; track type) {
                  <option [value]="type.code">{{type.definition}}</option>
                }
              </select>
              @if (fieldHasNotes(getFieldName(type.code, 'toolType')) || reviewStates?.includes(applicationState) ) {
                <span>
                  <view-notes [fieldName]="getFieldName(type.code, 'toolType')" [notes]="getFilteredNotes(getFieldName(type.code, 'toolType'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </td>
          </tr>
        }
        <!--<tr formGroupName="CDP">
        <td>Conductor/Drive Pipe</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|CDP|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|casingDiameter'" [notes]="getFilteredNotes('casingTubing|CDP|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|collarDiameter'" [notes]="getFilteredNotes('casingTubing|CDP|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|CDP|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|feetInstalled'" [notes]="getFilteredNotes('casingTubing|CDP|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|CDP|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|cementVolume'" [notes]="getFilteredNotes('casingTubing|CDP|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|cementTop'" [notes]="getFilteredNotes('casingTubing|CDP|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|grade'" [notes]="getFilteredNotes('casingTubing|CDP|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|weight'" [notes]="getFilteredNotes('casingTubing|CDP|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|CDP|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|CDP|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|CDP|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|CDP|toolType'" [notes]="getFilteredNotes('casingTubing|CDP|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="S">
        <td>Surface</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|S|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|S|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|S|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|casingDiameter'" [notes]="getFilteredNotes('casingTubing|S|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|S|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|collarDiameter'" [notes]="getFilteredNotes('casingTubing|S|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|S|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|feetInstalled'" [notes]="getFilteredNotes('casingTubing|S|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|S|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|S|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|S|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|cementVolume'" [notes]="getFilteredNotes('casingTubing|S|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|S|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|cementTop'" [notes]="getFilteredNotes('casingTubing|S|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|S|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|grade'" [notes]="getFilteredNotes('casingTubing|S|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|S|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|weight'" [notes]="getFilteredNotes('casingTubing|S|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|S|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|S|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|S|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|S|toolType'" [notes]="getFilteredNotes('casingTubing|S|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>


      <tr formGroupName="M">
        <td>Mine</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|M|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|M|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|M|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|casingDiameter'" [notes]="getFilteredNotes('casingTubing|M|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|M|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|collarDiameter'" [notes]="getFilteredNotes('casingTubing|M|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|M|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|feetInstalled'" [notes]="getFilteredNotes('casingTubing|M|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|M|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|M|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|M|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|cementVolume'" [notes]="getFilteredNotes('casingTubing|M|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|M|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|cementTop'" [notes]="getFilteredNotes('casingTubing|M|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|M|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|grade'" [notes]="getFilteredNotes('casingTubing|M|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|M|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|weight'" [notes]="getFilteredNotes('casingTubing|M|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|M|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|M|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|M|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|M|toolType'" [notes]="getFilteredNotes('casingTubing|M|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="I">
        <td>Intermediate</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|I|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|I|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|I|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|casingDiameter'" [notes]="getFilteredNotes('casingTubing|I|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|I|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|collarDiameter'" [notes]="getFilteredNotes('casingTubing|I|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|I|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|feetInstalled'" [notes]="getFilteredNotes('casingTubing|I|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|I|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|I|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|I|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|cementVolume'" [notes]="getFilteredNotes('casingTubing|I|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|I|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|cementTop'" [notes]="getFilteredNotes('casingTubing|I|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|I|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|grade'" [notes]="getFilteredNotes('casingTubing|I|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|I|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|weight'" [notes]="getFilteredNotes('casingTubing|I|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|I|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|I|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|I|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I|toolType'" [notes]="getFilteredNotes('casingTubing|I|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="I2">
        <td>Intermediate 2</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|I2|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|casingDiameter'" [notes]="getFilteredNotes('casingTubing|I2|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|collarDiameter'" [notes]="getFilteredNotes('casingTubing|I2|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|I2|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|feetInstalled'" [notes]="getFilteredNotes('casingTubing|I2|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|I2|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|cementVolume'" [notes]="getFilteredNotes('casingTubing|I2|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|cementTop'" [notes]="getFilteredNotes('casingTubing|I2|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|grade'" [notes]="getFilteredNotes('casingTubing|I2|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|weight'" [notes]="getFilteredNotes('casingTubing|I2|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|I2|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|I2|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|I2|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|I2|toolType'" [notes]="getFilteredNotes('casingTubing|I2|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="P">
        <td>Production</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|P|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|P|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|P|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|casingDiameter'" [notes]="getFilteredNotes('casingTubing|P|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|P|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|collarDiameter'" [notes]="getFilteredNotes('casingTubing|P|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|P|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|feetInstalled'" [notes]="getFilteredNotes('casingTubing|P|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|P|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|P|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|P|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|cementVolume'" [notes]="getFilteredNotes('casingTubing|P|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|P|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|cementTop'" [notes]="getFilteredNotes('casingTubing|P|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|P|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|grade'" [notes]="getFilteredNotes('casingTubing|P|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|P|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|weight'" [notes]="getFilteredNotes('casingTubing|P|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|P|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|P|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|P|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P|toolType'" [notes]="getFilteredNotes('casingTubing|P|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="P2">
        <td>Production 2</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|P2|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|casingDiameter'" [notes]="getFilteredNotes('casingTubing|P2|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|collarDiameter'" [notes]="getFilteredNotes('casingTubing|P2|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|P2|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|feetInstalled'" [notes]="getFilteredNotes('casingTubing|P2|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|P2|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|cementVolume'" [notes]="getFilteredNotes('casingTubing|P2|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|cementTop'" [notes]="getFilteredNotes('casingTubing|P2|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|grade'" [notes]="getFilteredNotes('casingTubing|P2|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|weight'" [notes]="getFilteredNotes('casingTubing|P2|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|P2|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|P2|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|P2|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|P2|toolType'" [notes]="getFilteredNotes('casingTubing|P2|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="T">
        <td>Tubing</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|T|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|T|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|T|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|casingDiameter'" [notes]="getFilteredNotes('casingTubing|T|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|T|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|collarDiameter'" [notes]="getFilteredNotes('casingTubing|T|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|T|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|feetInstalled'" [notes]="getFilteredNotes('casingTubing|T|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|T|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|T|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|T|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|cementVolume'" [notes]="getFilteredNotes('casingTubing|T|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|T|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|cementTop'" [notes]="getFilteredNotes('casingTubing|T|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|T|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|grade'" [notes]="getFilteredNotes('casingTubing|T|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|T|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|weight'" [notes]="getFilteredNotes('casingTubing|T|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|T|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|T|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|T|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|T|toolType'" [notes]="getFilteredNotes('casingTubing|T|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>

      <tr formGroupName="O">
        <td>Other</td>
        <td style="width: 100px">
          <input type="number" formControlName="wellboreDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|O|wellboreDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|wellboreDiameter'" [notes]="getFilteredNotes('casingTubing|O|wellboreDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 100px">
          <input type="number" formControlName="casingDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|O|casingDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|casingDiameter'" [notes]="getFilteredNotes('casingTubing|O|casingDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>


        </td>
        <td style="width: 100px">
          <input type="number" formControlName="collarDiameter" />
          <span *ngIf="fieldHasNotes('casingTubing|O|collarDiameter') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|collarDiameter'" [notes]="getFilteredNotes('casingTubing|O|collarDiameter')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>
        <td style="width: 100px">
          <input type="number" formControlName="feetInstalled" />

          <span *ngIf="fieldHasNotes('casingTubing|O|feetInstalled') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|feetInstalled'" [notes]="getFilteredNotes('casingTubing|O|feetInstalled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>

        </td>

        <td style="width: 300px">
          <input type="number" formControlName="feetLeftInWall" />
          <span *ngIf="fieldHasNotes('casingTubing|O|feetLeftInWall') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|feetLeftInWall'" [notes]="getFilteredNotes('casingTubing|O|feetLeftInWall')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="cementVolume" />
          <span *ngIf="fieldHasNotes('casingTubing|O|cementVolume') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|cementVolume'" [notes]="getFilteredNotes('casingTubing|O|cementVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 100px">
          <input type="number" formControlName="cementTop" />
          <span *ngIf="fieldHasNotes('casingTubing|O|cementTop') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|cementTop'" [notes]="getFilteredNotes('casingTubing|O|cementTop')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="grade" />
          <span *ngIf="fieldHasNotes('casingTubing|O|grade') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|grade'" [notes]="getFilteredNotes('casingTubing|O|grade')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 200px">
          <input type="number" formControlName="weight" />
          <span *ngIf="fieldHasNotes('casingTubing|O|weight') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|weight'" [notes]="getFilteredNotes('casingTubing|O|weight')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td>
          <input type="number" formControlName="burstPressureRating" />
          <span *ngIf="fieldHasNotes('casingTubing|O|burstPressureRating') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|burstPressureRating'" [notes]="getFilteredNotes('casingTubing|O|burstPressureRating')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>

        <td style="width: 1100px">
          <select formControlName="toolType">

            <option *ngFor="let type of toolTypes" [value]="type.code">{{type.definition}}</option>
          </select>
          <span *ngIf="fieldHasNotes('casingTubing|O|toolType') || reviewStates?.includes(applicationState) ">
            <view-notes [fieldName]="'casingTubing|O|toolType'" [notes]="getFilteredNotes('casingTubing|O|toolType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        </td>
      </tr>-->



    </tbody>
  </table>


</div>
</ng-container>